import { render, staticRenderFns } from "./PublicationCheckbox.vue?vue&type=template&id=2f534655&scoped=true"
import script from "./PublicationCheckbox.vue?vue&type=script&lang=js"
export * from "./PublicationCheckbox.vue?vue&type=script&lang=js"
import style0 from "./PublicationCheckbox.vue?vue&type=style&index=0&id=2f534655&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f534655",
  null
  
)

export default component.exports